import { render } from "./appointmentAdd.vue?vue&type=template&id=40d62e23&scoped=true&ts=true"
import script from "./appointmentAdd.vue?vue&type=script&lang=ts"
export * from "./appointmentAdd.vue?vue&type=script&lang=ts"

import "./appointmentAdd.vue?vue&type=style&index=0&id=40d62e23&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40d62e23"]])

export default __exports__